import {combineReducers} from 'redux';
import {loginReducerKey} from 'features/login/redux/types';
import loginReducer, {loginInitialState} from '../features/login/redux/reducer';
import {notificationsReducerKey} from 'features/notifications/redux/types';
import notificationsReducer, {
   notificationsInitialState,
} from '../features/notifications/redux/reducer';
import {layoutReducerKey} from 'features/layout/redux/types';
import layoutReducer, {initialLayoutState} from '../features/layout/redux/reducer';
import {licenseKey} from './license/types';
import licenseReducer, {licenseInitialState} from './license/reducer';
import {settingsReducerKey} from './settings/types';
import settingsReducer, {settingsInitialState} from './settings/reducer';
import {commonPageKey} from 'features/layout/CommonPage/redux/types';
import commonPageReducer, {
   initialCommonPageState,
} from '../features/layout/CommonPage/redux/reducer';
import {partnersReducerKey} from './partners/types';
import partnersReducer, {partnersInitialState} from './partners/reducer';
import keysReducer, {keysInitialState} from './keys/reducer';
import {keysKey} from './keys/types';
import {transactionsReducerKey} from './transactions/types';
import transactionsReducer, {transactionsInitialState} from './transactions/reducer';
import {serverKey} from './server/types';
import serverReducer, {serverInitialState} from './server/reducer';

export type State = {
   [loginReducerKey]: typeof loginInitialState;
   [notificationsReducerKey]: typeof notificationsInitialState;
   [layoutReducerKey]: typeof initialLayoutState;
   [licenseKey]: typeof licenseInitialState;
   [commonPageKey]: typeof initialCommonPageState;
   [settingsReducerKey]: typeof settingsInitialState;
   [partnersReducerKey]: typeof partnersInitialState;
   [keysKey]: typeof keysInitialState;
   [transactionsReducerKey]: typeof transactionsInitialState;
   [serverKey]: typeof serverInitialState;
};

const createRootReducer = () =>
   combineReducers({
      [loginReducerKey]: loginReducer,
      [notificationsReducerKey]: notificationsReducer,
      [layoutReducerKey]: layoutReducer,
      [licenseKey]: licenseReducer,
      [commonPageKey]: commonPageReducer,
      [settingsReducerKey]: settingsReducer,
      [partnersReducerKey]: partnersReducer,
      [keysKey]: keysReducer,
      [transactionsReducerKey]: transactionsReducer,
      [serverKey]: serverReducer,
   });

export default createRootReducer;
